import React from 'react';
import './App.css';
import './styles/normal.css';
import Chat from './pages/Chat';
import { Routes, Route, Navigate } from 'react-router-dom';
import Landing from './pages/Landing';
import GoogleCallback from './pages/GoogleCallback';
import { Provider } from 'react-redux';
import Store from './components/Store';
import Layout from './Layout';
import ChatShell from './layouts/ChatShell';

function App() {
  return (
    <Provider store={Store}>
      <Routes>
        <Route
          path="/"
          element={
            <Layout>
              <Landing />
            </Layout>
          }
        />
        <Route path="/login" element={<Navigate to="/" replace state={{ signIn: true }} />} />
        <Route path="/register" element={<Navigate to="/" replace state={{ signIn: true }} />} />
        <Route path="/auth/google/callback" element={<GoogleCallback />} />
        <Route
          path="/chat"
          element={
            <ChatShell>
              <Chat />
            </ChatShell>
          }
        />
      </Routes>
    </Provider>
  );
}

export default App;
